import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '@utils/route.utils.ts';
import useProfileStore from '@store/profile-store/profile.store.ts';
import { UserRole } from '@utils/roles-utils.ts';

const RoleBasedRedirect: React.FC = () => {
  const { profileData } = useProfileStore();
  const navigate = useNavigate();

  useEffect(() => {
    const userRoles = profileData?.roles?.map((r: any) => r.name) || [];

    if (
      userRoles.includes(UserRole.SUPER_ADMIN) ||
      userRoles.includes(UserRole.PARTNER)
    ) {
      navigate(RoutePaths.Core.HotelManagement.absolutePath, { replace: true });
    } else {
      navigate(RoutePaths.Core.Analytics.absolutePath, { replace: true });
    }
  }, [profileData, navigate]);

  return null;
};

export default RoleBasedRedirect;
